import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-f9ec4216"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["width", "height", "viewBox"];
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<defs data-v-f9ec4216><linearGradient id=\"strandA\" x1=\"0\" y1=\"0\" x2=\"1\" y2=\"0\" data-v-f9ec4216><stop offset=\"0%\" stop-color=\"#2b8bd6\" data-v-f9ec4216></stop><stop offset=\"100%\" stop-color=\"#0b5ea8\" data-v-f9ec4216></stop></linearGradient><linearGradient id=\"strandB\" x1=\"0\" y1=\"0\" x2=\"1\" y2=\"0\" data-v-f9ec4216><stop offset=\"0%\" stop-color=\"#f07a6a\" data-v-f9ec4216></stop><stop offset=\"100%\" stop-color=\"#c94b3d\" data-v-f9ec4216></stop></linearGradient><linearGradient id=\"rungGrad\" x1=\"0\" y1=\"0\" x2=\"0\" y2=\"1\" data-v-f9ec4216><stop offset=\"0%\" stop-color=\"#f3b64b\" data-v-f9ec4216></stop><stop offset=\"50%\" stop-color=\"#f3b64b\" data-v-f9ec4216></stop><stop offset=\"100%\" stop-color=\"#5dbb63\" data-v-f9ec4216></stop></linearGradient></defs>", 1);
const _hoisted_3 = ["d", "stroke-width"];
const _hoisted_4 = ["d", "stroke-width"];
const _hoisted_5 = ["x", "y", "width", "height", "opacity"];
const _hoisted_6 = ["x", "y", "font-size", "opacity"];
const _hoisted_7 = ["x", "y", "font-size", "opacity"];
import { computed } from "vue";
export default {
  __name: 'DnaHelix',
  props: {
    pairs: {
      type: Array,
      default: () => []
    },
    width: {
      type: Number,
      default: 720
    },
    height: {
      type: Number,
      default: 220
    },
    cycles: {
      type: Number,
      default: 1.35
    },
    marginX: {
      type: Number,
      default: 40
    },
    marginY: {
      type: Number,
      default: 22
    },
    strandWidth: {
      type: Number,
      default: 16
    },
    rungWidth: {
      type: Number,
      default: 28
    },
    fontSize: {
      type: Number,
      default: 18
    }
  },
  setup(__props) {
    const props = __props;
    const px = v => `${v}px`;
    const W = computed(() => props.width);
    const H = computed(() => props.height);
    const cy = computed(() => H.value / 2);
    const usableW = computed(() => W.value - props.marginX * 2);
    const amplitude = computed(() => Math.max(24, (H.value - props.marginY * 2) * 0.28)); // 波动幅度
    const leftPad = computed(() => props.marginX);
    function parsePair(s) {
      const t = (s || "").trim();
      const [a, b] = t.split("-").map(x => (x ?? "").trim());
      return {
        left: (a || "?").slice(0, 2),
        right: (b || "?").slice(0, 2)
      };
    }

    /**
     * DNA 两条链：y = cy +/- amp * sin(phase)
     * x 取 [marginX, width-marginX]
     */
    function makePath(phaseShift) {
      const n = Math.max(80, props.pairs.length * 20);
      const x0 = leftPad.value;
      const x1 = leftPad.value + usableW.value;
      let d = "";
      for (let i = 0; i <= n; i++) {
        const t = i / n; // 0..1
        const x = x0 + t * (x1 - x0);
        const phase = t * Math.PI * 2 * props.cycles + phaseShift;
        const y = cy.value + amplitude.value * Math.sin(phase);
        d += i === 0 ? `M ${x.toFixed(2)} ${y.toFixed(2)}` : ` L ${x.toFixed(2)} ${y.toFixed(2)}`;
      }
      return d;
    }
    const pathA = computed(() => makePath(0));
    const pathB = computed(() => makePath(Math.PI)); // 相位相反

    /**
     * 梯级：每个 pair 放一个竖条，顶部连到 A 链，底部连到 B 链
     * 关键改动：把碱基对“吸附”到螺旋张开最大的中间区域（峰/谷），避开交叉点附近（sin≈0）
     */
    const rungs = computed(() => {
      const N = Math.max(1, props.pairs.length);
      const x0 = leftPad.value;
      const x1 = leftPad.value + usableW.value;
      return props.pairs.map((p, i) => {
        const {
          left,
          right
        } = parsePair(p);

        // 0..1 across width (use center points)
        const u = N === 1 ? 0.5 : (i + 0.5) / N;

        // 给两端留更多空白，避免竖条贴边造成“挤在两侧”的感觉
        const inset = 0.06; // 6% inset on each side
        const tX = inset + u * (1 - inset * 2);
        const x = x0 + tX * (x1 - x0);

        // 关键：把碱基对的相位固定到“张开最大”的区域（峰/谷），避开交叉点附近（sin≈0）
        // 先做一个整体的 90° 相位偏移，让默认分布更接近峰/谷
        const total = Math.PI * 2 * props.cycles;
        let phase = tX * total + Math.PI / 2;

        // 如果仍然靠近交叉点，则吸附到最近的峰/谷：phase = π/2 + kπ
        const s = Math.sin(phase);
        const minOpen = 0.55; // 越大越“只在中间”，0.5~0.7 之间可调
        if (Math.abs(s) < minOpen) {
          const k = Math.round((phase - Math.PI / 2) / Math.PI);
          phase = Math.PI / 2 + k * Math.PI;
        }

        // A 链和 B 链在这个 x 对应的 y（用调整后的 phase）
        const yA = cy.value + amplitude.value * Math.sin(phase);
        const yB = cy.value + amplitude.value * Math.sin(phase + Math.PI);
        const yTop = Math.min(yA, yB);
        const yBottom = Math.max(yA, yB);

        // 深度（用于不透明度/层级）：用 cos(phase) 模拟前后
        const depth = (Math.cos(phase) + 1) / 2; // 0..1
        const opacity = 0.4 + depth * 0.5; // 0.4..0.9
        const textOpacity = 0.55 + depth * 0.45;
        return {
          i,
          x,
          yTop,
          yBottom,
          left,
          right,
          depth,
          opacity,
          textOpacity
        };
      });
    });

    /** 让“更靠前”的竖条画在上层，避免视觉穿帮 */
    const sortedRungs = computed(() => [...rungs.value].sort((a, b) => a.depth - b.depth));
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: "dna-wrap",
        style: _normalizeStyle({
          width: px(__props.width)
        })
      }, [(_openBlock(), _createElementBlock("svg", {
        width: __props.width,
        height: __props.height,
        viewBox: `0 0 ${__props.width} ${__props.height}`,
        role: "img",
        "aria-label": "DNA"
      }, [_hoisted_2, _createElementVNode("path", {
        d: pathA.value,
        fill: "none",
        stroke: "url(#strandA)",
        "stroke-width": __props.strandWidth,
        "stroke-linecap": "round"
      }, null, 8, _hoisted_3), _createElementVNode("path", {
        d: pathB.value,
        fill: "none",
        stroke: "url(#strandB)",
        "stroke-width": __props.strandWidth,
        "stroke-linecap": "round"
      }, null, 8, _hoisted_4), _createElementVNode("g", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedRungs.value, r => {
        return _openBlock(), _createElementBlock("g", {
          key: r.i
        }, [_createElementVNode("rect", {
          x: r.x - __props.rungWidth / 2,
          y: r.yTop,
          width: __props.rungWidth,
          height: r.yBottom - r.yTop,
          rx: "6",
          ry: "6",
          fill: "url(#rungGrad)",
          opacity: r.opacity
        }, null, 8, _hoisted_5), _createElementVNode("text", {
          x: r.x,
          y: r.yTop + 18,
          "text-anchor": "middle",
          "dominant-baseline": "middle",
          "font-size": __props.fontSize,
          "font-weight": "700",
          fill: "#111",
          opacity: r.textOpacity
        }, _toDisplayString(r.left), 9, _hoisted_6), _createElementVNode("text", {
          x: r.x,
          y: r.yBottom - 18,
          "text-anchor": "middle",
          "dominant-baseline": "middle",
          "font-size": __props.fontSize,
          "font-weight": "700",
          fill: "#111",
          opacity: r.textOpacity
        }, _toDisplayString(r.right), 9, _hoisted_7)]);
      }), 128))])], 8, _hoisted_1))], 4);
    };
  }
};